import { useState, useEffect } from 'react';

/**
 * Custom hook to manage success and error notifications with auto-dismiss
 * @returns {Object} Notification state and handlers
 */
export const useNotifications = () => {
  const [success, setSuccess] = useState('');
  const [error, setError] = useState('');
  const [successTimeoutId, setSuccessTimeoutId] = useState(null);

  /**
   * Show a success message with auto-dismiss
   * @param {string} message - Success message to display
   * @param {number} duration - Duration in milliseconds before auto-dismiss
   */
  const showSuccess = (message, duration = 3000) => {
    // Clear any existing timeout
    if (successTimeoutId) {
      clearTimeout(successTimeoutId);
    }

    setSuccess(message);

    // Set new timeout to clear message
    const timeoutId = setTimeout(() => {
      setSuccess('');
    }, duration);

    setSuccessTimeoutId(timeoutId);
  };

  /**
   * Show an error message
   * @param {string} message - Error message to display
   */
  const showError = (message) => {
    setError(message);
  };

  /**
   * Clear all notifications
   */
  const clearNotifications = () => {
    setSuccess('');
    setError('');
  };

  // Cleanup timeout on unmount
  useEffect(() => {
    return () => {
      if (successTimeoutId) {
        clearTimeout(successTimeoutId);
      }
    };
  }, [successTimeoutId]);

  return {
    success,
    error,
    showSuccess,
    showError,
    clearNotifications,
    setError,
    setSuccess,
  };
};
